import FormGroup from '@material-ui/core/FormGroup';
import React, { memo, useState } from 'react';
import { getWebAbsPath } from '../../../util/path';
import styles from './Teeth.module.css';
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import * as actionTypes from '../../../store/NewPatient/actionType';
import { teethGapConfig } from '../TeethGapConfig';

const TeethSelect = ({
    defaultTeethArray = undefined,
    teethConfig = teethGapConfig,
    imageNameInPrescriptionNotesFolder = `checkFail`,
    actionReducer = actionTypes.NEW_PATIENT_TEETH_INCLUDED_GAP,
    stateReducer = 'teethIncludedGap',
}) => {
    const dispatch = useDispatch();
    const teethArray = useSelector((state) => state.newPatientReducer[stateReducer]);

    const handleDataSelect = (value) => {
        dispatch({ type: actionTypes[actionReducer], value: value });
    };

    const handleClick = (e, func) => {
        const { left, top } = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - left;
        const y = e.clientY - top;

        for (let [_, objValue] of Object.entries(teethConfig)) {
            if (x > objValue.maxX || x < objValue.minX || y > objValue.maxY || y < objValue.minY) continue;
            for (let i = 0; i < objValue.values.length; i++) {
                const { value, boundX } = objValue.values[i];
                if (boundX < x) continue;
                func(value);
                break;
            }
            break;
        }
    };

    // Dubug button
    // const submit = () => {
    //     console.log(teethArray)
    // }

    return (
        <FormGroup>
            <ol className={styles.list}>
                <div className={styles.toothImages}>
                    <div
                        style={{
                            width: 1175,
                            height: 300,
                            marginTop: '10px',
                            position: 'relative',
                            backgroundRepeat: 'no-repeat',
                            backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/teeth_number_CS6.ai.png')}")`,
                        }}
                        onClick={(e) => {
                            if (defaultTeethArray === undefined) {
                                handleClick(e, handleDataSelect);
                            }
                        }}
                    >
                        {(defaultTeethArray ? defaultTeethArray : teethArray).map((toothValue) => {
                            for (let [_, objValue] of Object.entries(teethConfig)) {
                                for (let { value, positionX, positionY } of objValue.values) {
                                    if (value === toothValue) {
                                        return (
                                            <img
                                                src={getWebAbsPath(
                                                    `/img/prescriptionNotes/${imageNameInPrescriptionNotesFolder}.png`
                                                )}
                                                alt="checked"
                                                style={{
                                                    position: 'absolute',
                                                    top: positionY - 10,
                                                    left: positionX - 12,
                                                    userSelect: 'none',
                                                }}
                                            />
                                        );
                                    }
                                }
                            }
                        })}
                    </div>
                </div>
            </ol>

            {/* Debug button */}
            {/* <Button onClick={submit}>click</Button> */}
        </FormGroup>
    );
};

export default memo(TeethSelect);
